<template>
  <div>
    <p class="category">Poll Question Generation</p>
    <div class="container text-left">
      <p>
        This task aims to generate poll questions for social media posts.
        As we know, social media is a crucial outlet for people to exchange ideas, share viewpoints, and keep connected
        with the world.
      </p>
      <p>
        It allows us to hear the public voice for decision-making and better understand our society.
        Nevertheless, for the silent majority, they tend to read others' messages instead of voicing their own opinions
        with words, possibly because of the introverted personality, busy schedule, and others.
      </p>
      <p>
        To automatically generate a poll question for a social media post will encourage public users, especially those
        reluctant to comment with words, to input their reflections via voting and thus have a better engagement.
      </p>
      <p>
        The dataset is consisted of files names <strong>src</strong> (the source post), <strong>conv</strong> (comments
        for the source post), <strong>trg</strong> (generated question) and
        <strong>choice</strong>
        (generated choices).
        Each row presents a data instance which is showing in the table below.
        All the text has been preprocessed by jieba.
        ROUGE-1 is adopted as <strong>evaluation metrics</strong>.
      </p>
      <div class="my-3">
        <el-table :data="tableData" style="width: 100%" border>
          <el-table-column prop="file" label="File" min-width="150"></el-table-column>
          <el-table-column prop="text" label="Text" min-width="600"></el-table-column>
        </el-table>
      </div>
      <div>
        <span class="h6 mr-2">Data resources: </span>
        <a href="/resource_social22/data/data_poll.zip">data_poll.zip</a>
      </div>
      <div>
        <span class="h6 mr-2">Baseline Implementation: </span>
        <a href="https://github.com/polyusmart/Poll-Question-Generation" target="_blank">
          https://github.com/polyusmart/Poll-Question-Generation
        </a>
      </div>
      <div>
        <span class="h6 mr-2">Pytorch tutorial: </span>
        <a href="https://pytorch.org/tutorials/intermediate/seq2seq_translation_tutorial.html?highlight=sequence%20sequence"
           target="_blank">
          https://pytorch.org/tutorials/intermediate/seq2seq_translation_tutorial.html
        </a>
      </div>
      <p class="mt-3">Uploading results should be saved as a <strong>.txt</strong> file like this:</p>
      <v-card class="px-3 py-2">
        <div>快递 柜 收费 你 会 继续 使用 吗</div>
        <div>你 第一眼 认出 谁 了</div>
      </v-card>
      <p>Where each row represents the generated poll question.</p>
      <p>More information can be found through the published paper below.</p>
      <v-card class="pt-2">
        <v-md-editor mode="preview" ref="editor" height="100%" v-model="content" class="px-md-5"></v-md-editor>
      </v-card>

    </div>
  </div>
</template>

<script>

export default {
  name: "taskPoll",
  data() {
    return {
      tableData: [
        {
          'file': 'src',
          'text': '奥运 若 不 延期 加澳 两国 拒 参赛 今天上午 澳大利亚 和 加拿大 宣布 在 目前 的 形势 下 如果 东京 奥运会 不 做出 延期 他们 将 不会 派遣 运动员 参赛',
        },
        {
          'file': 'conv',
          'text': '加拿大 应该 先 提出 建议 和 顾虑 而 不是 直接 宣布 退赛 这会 起到 骨牌效应 的 因为 疫情 欧美 澳亚 各洲 各国 的 运动员 训练 比赛 已经 不 正常 了 赛前 节奏 比赛 状态 都 被打乱 很多 单项 体育 组织 的 奥运 资格赛 还 没有 比完 日本 场馆 的 奥运 测试 赛 也 没有 开展 至于 门票 欧美 亚 的 观众 愿意 冒 这个 风险 吗 日本 的 疫情 数字 连 孙正义 的 检测 帮助 都 要 拒绝 真实情况 只能 呵呵 了 奥运 若 不 延期 加澳 两国 拒 参赛 希望 疫情 能 得到 缓和 奥运 若 不 延期 加澳',
        },
        {
          'file': 'trg',
          'text': '你 觉得 奥运会 该 延期 吗',
        },
        {
          'file': 'choice',
          'text': '应该 先 控制 疫情 <sep> 不用 做好 安全措施 就行 <sep> 不好 说 看 情况 而定',
        },
      ],
      content: `
\`\`\`
@inproceedings{lu-etal-2021-engage,
    title = "Engage the Public: Poll Question Generation for Social Media Posts",
    author = "Lu, Zexin  and
      Ding, Keyang  and
      Zhang, Yuji  and
      Li, Jing  and
      Peng, Baolin  and
      Liu, Lemao",
    booktitle = "Proceedings of the 59th Annual Meeting of the Association for Computational Linguistics and the 11th International Joint Conference on Natural Language Processing (Volume 1: Long Papers)",
    month = aug,
    year = "2021",
    address = "Online",
    publisher = "Association for Computational Linguistics",
    url = "https://aclanthology.org/2021.acl-long.3",
    doi = "10.18653/v1/2021.acl-long.3",
    pages = "29--40",
}
\`\`\`
`,
    }
  }
}
</script>

<style scoped>

</style>